shibaridojo = {
  'forms': {		
		'params': {
			'validate': function(form, requiredParams){
				var failed=false;
				form.find('.has-error').removeClass('has-error');
				form.find('.errornotice').hide();
				var isEmail = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/,
					loadingIcon = '<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>';
				$.each( requiredParams, function( name, type ) {
					if (type == "email") {
						if (!isEmail.test(form.find("input[name='"+name+"']").val())) {
							form.find("input[name='"+name+"']").parents( ".form-group" ).addClass('has-error');
							failed=true;
						}
					}
					if (type == "text") {
						if(!form.find("input[name='"+name+"']").val()) {
							form.find("input[name='"+name+"']").parents( ".form-group" ).addClass('has-error');
							failed=true;
						}
					}
					if (type == "phone") {
						if(!form.find("input[name='"+name+"']").val()) {
							form.find("input[name='"+name+"']").parents( ".form-group" ).addClass('has-error');
							failed=true;
						}
					}
					if (type == "checkbox") { 
						if(!form.find("input[name='"+name+"']").is(":checked")) {
							form.find("input[name='"+name+"']").parents( ".form-group" ).addClass('has-error');
							failed=true;
						}   
					}
					if (type == "textarea") {
						if(!form.find("textarea[name='"+name+"']").val()) {
							form.find("textarea[name='"+name+"']").parents( ".form-group" ).addClass('has-error');
							failed=true;
						}   
					}
					if (type == "select") {
						if(!form.find("select[name='"+name+"']").val() || form.find("select[name='"+name+"']").val() == "default" ) {
							form.find("select[name='"+name+"']").parents( ".form-group" ).addClass('has-error');
							failed=true;
						}   
					}
				});
				return failed;
			},
			'process': function(form, params){
				var dataSet = {};                    
				$.each( params, function( name, type ) {
					var value ="";                
					if (type == "email") {
						value = form.find("input[name='"+name+"']").val();
					}
					if (type == "text") {
						value = form.find("input[name='"+name+"']").val()
					}
					if (type == "checkbox") {
						value = form.find("input[name='"+name+"']").val();
					}                
					if (type == "radio") {
						value = form.find("input[name='"+name+"']:checked").val();
					}
					if (type == "select") {
						value = form.find("select[name='"+name+"'] option:selected").val()
					}
					if (type == "textarea") {
						value = form.find("textarea[name='"+name+"']").val()
					}
					dataSet[name] = value;                
				});
				return dataSet;
			},	
		},	
		'newsletter_subscribe': {
			'send': function(form_name){
				
				var form = $( "#form_" + form_name);
				var params = {};
				params["email"] = "email"; 
				
				var failed = shibaridojo.forms.params.validate(form, params);
				
				form.find("button").addClass("loading");
				var dataSet = shibaridojo.forms.params.process(form, params);
				dataSet['domain'] = cyclone3.domain;
				
				$.ajax({
					type: "POST",
					dataType: 'json',
					url: cyclone3.domain + '/json/newsletter/subscribe',
					data: dataSet,
					success: function(data) {
						if( data.success != true)
						{
							form.find('.errornotice').text(data.errors);
							form.find('.errornotice').slideDown('fast');
						}
						else
						{
							form.find(".input-group").hide();                            
						}
						form.find("button").removeClass("loading");
					}
				}); 
			}
		},
		'event_registration': {
			'send': function(form_name){
				
				var form = $( "#form_" + form_name);
				var params = {};
				params["email"] = "email";
				params["name"] = "text";
				params["attendee_type"] = "select";
				params["payment"] = "select";
				params["gdpr"] = "checkbox"; 
				
				var failed = shibaridojo.forms.params.validate(form, params);
				
				form.find("button").addClass("loading");
				if (failed == false)
				{
				  $.ajax({
					  type: "POST",
					  dataType: 'json',
					  url: cyclone3.domain + '/json/event/registration',
					  data: form.serialize(),
					  
					  error: function (xhr, ajaxOptions, thrownError) {
						console.log(xhr.status);
						console.log(thrownError);
					  },
					  done: function(data) {
						console.log("done");  
					  },
					  success: function(data) {
						
						  form.find("button").removeClass("loading");
						  if( data.success != true)
						  {
							$('.errornotice .alert').text(data.error_msg);
							$('.errornotice').slideDown('fast');
							$.each(data.invalid, function( index, value ) {
								console.log("invalid "+value);
								form.find("input[name='"+value+"']").parents( ".form-group" ).addClass('has-error');
							});
						  }
						  else
						  {
							  form.hide();
							  $('.successnotice').slideDown('fast');
							  onPurchase();
						  }
					  }
				  });				
                }
			}
		}
	}
};



(function ($) {
    'use strict';

	$(document).ready(function($) {
	  $( "#newsletter_subscribe" ).on( "click", function(evt) {
		  shibaridojo.forms.newsletter_subscribe.send("newsletter_subscribe");
		  cyclone3.cancelEvent(evt);
		  evt.stopPropagation();    	
	  });
	  
	  $( "#event_registration_form_submit" ).on( "click", function(evt) {
		  shibaridojo.forms.event_registration.send("event_registration");
		  cyclone3.cancelEvent(evt);
		  evt.stopPropagation();    	
	  });
	  

	  var browserWindow = $(window);
	  
	  // :: 1.0 Preloader Active Code
	  $('#preloader').fadeOut('slow', function () {
		$(this).remove();
	  });
	  browserWindow.on('load', function () {
  
	  });
  
	  // :: 3.0 Nav Active Code
	  if ($.fn.classyNav) {
		  $('#deliciousNav').classyNav();
	  }
	  
	  // :: 4.0 Search Active Code
	  var searchwrapper = $('.search-wrapper');
	  $('.search-btn').on('click', function () {
		  searchwrapper.toggleClass('on');
	  });
	  $('.close-btn').on('click', function () {
		  searchwrapper.removeClass('on');
	  });
  
	  // :: 5.0 Sliders Active Code
	  if ($.fn.owlCarousel) {
		  var welcomeSlide = $('.hero-slides');
		  var receipeSlide = $('.receipe-slider');
  
		  welcomeSlide.owlCarousel({
			  items: 1,
			  margin: 0,
			  loop: true,
			  nav: true,
			  navText: ['Prev', 'Next'],
			  dots: true,
			  autoplay: true,
			  autoplayTimeout: 20000,
			  smartSpeed: 1000
		  });
  
		  welcomeSlide.on('translate.owl.carousel', function () {
			  var slideLayer = $("[data-animation]");
			  slideLayer.each(function () {
				  var anim_name = $(this).data('animation');
				  $(this).removeClass('animated ' + anim_name).css('opacity', '0');
			  });
		  });
  
		  welcomeSlide.on('translated.owl.carousel', function () {
			  var slideLayer = welcomeSlide.find('.owl-item.active').find("[data-animation]");
			  slideLayer.each(function () {
				  var anim_name = $(this).data('animation');
				  $(this).addClass('animated ' + anim_name).css('opacity', '1');
			  });
		  });
  
		  $("[data-delay]").each(function () {
			  var anim_del = $(this).data('delay');
			  $(this).css('animation-delay', anim_del);
		  });
  
		  $("[data-duration]").each(function () {
			  var anim_dur = $(this).data('duration');
			  $(this).css('animation-duration', anim_dur);
		  });
  
		  var dot = $('.hero-slides .owl-dot');
		  dot.each(function () {
			  var index = $(this).index() + 1 + '.';
			  if (index < 10) {
				  $(this).html('0').append(index);
			  } else {
				  $(this).html(index);
			  }
		  });
  
		  receipeSlide.owlCarousel({
			  items: 1,
			  margin: 0,
			  loop: true,
			  nav: true,
			  navText: ['Prev', 'Next'],
			  dots: true,
			  autoplay: true,
			  autoplayTimeout: 5000,
			  smartSpeed: 1000
		  });
	  }
  
	  // :: 6.0 Gallery Active Code
	  if ($.fn.magnificPopup) {
		  $('.videobtn').magnificPopup({
			  type: 'iframe'
		  });
		  
	  }
  
	  // :: 7.0 ScrollUp Active Code
	  $(function () {
		  $.scrollUp({
			  scrollText: '<i class="fa fa-angle-up"></i>',
			  topSpeed: 1500,
		  });
	  });
  
	  // :: 8.0 CouterUp Active Code
	  if ($.fn.counterUp) {
		  $('.counter').counterUp({
			  delay: 10,
			  time: 2000
		  });
	  }
  
	  // :: 9.0 nice Select Active Code
	  if ($.fn.niceSelect) {
		  $('select').niceSelect();
	  }
  
	  // :: 10.0 wow Active Code
	  if (browserWindow.width() > 767) {
		  new WOW().init();
	  }
  
	  // :: 11.0 prevent default a click
	  $('a[href="#"]').click(function ($) {
		  $.preventDefault()
	  });
  
	  // initialize gallery masonry grid
	  var gridGallery = $('.grid-gallery');
	  var $masonryGallery = gridGallery.masonry({
		  itemSelector: '.grid-item.active',
		  columnWidth: 250,
		  gutter: 45,
		  isFitWidth: true,
		  horizontalOrder: true
	  });
	  
	});

})(jQuery);
